import { render, staticRenderFns } from "./general-strategy.vue?vue&type=template&id=9e931be6&scoped=true"
import script from "./general-strategy.vue?vue&type=script&lang=ts"
export * from "./general-strategy.vue?vue&type=script&lang=ts"
import style0 from "./general-strategy.vue?vue&type=style&index=0&id=9e931be6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e931be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e931be6')) {
      api.createRecord('9e931be6', component.options)
    } else {
      api.reload('9e931be6', component.options)
    }
    module.hot.accept("./general-strategy.vue?vue&type=template&id=9e931be6&scoped=true", function () {
      api.rerender('9e931be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general-startegy/general-strategy.vue"
export default component.exports